export const SUPPORT_EMAIL = "support@sayvero.com";
